import { useState, useEffect, useCallback } from "react"
import { ConsentContext, type ConsentStatus } from "./consent-context"
import { Analytics } from "@/lib/analytics"
import { grantAnalyticsConsent, revokeAnalyticsConsent } from "@/lib/gtag"

const STORAGE_KEY = "beediv-consent"

export function ConsentProvider({ children }: { children: React.ReactNode }) {
	const [status, setStatus] = useState<ConsentStatus>(() => {
		const stored = localStorage.getItem(STORAGE_KEY)
		if (stored === "accepted" || stored === "declined") return stored
		return null
	})

	// On mount, if already accepted, activate analytics
	useEffect(() => {
		if (status === "accepted") {
			Analytics.init()
			grantAnalyticsConsent()
		} else if (status === "declined") {
			revokeAnalyticsConsent()
		}
	}, []) // eslint-disable-line react-hooks/exhaustive-deps

	const accept = useCallback(() => {
		localStorage.setItem(STORAGE_KEY, "accepted")
		setStatus("accepted")
		Analytics.init()
		grantAnalyticsConsent()
	}, [])

	const decline = useCallback(() => {
		localStorage.setItem(STORAGE_KEY, "declined")
		setStatus("declined")
		Analytics.shutdown()
		revokeAnalyticsConsent()
	}, [])

	const reset = useCallback(() => {
		localStorage.removeItem(STORAGE_KEY)
		setStatus(null)
	}, [])

	return <ConsentContext.Provider value={{ status, accept, decline, reset }}>{children}</ConsentContext.Provider>
}
